import { useState } from 'react'
import { useIntl } from 'react-intl'
import { Navigate } from 'react-router-dom'
import { observer } from 'mobx-react'

import {
  ERROR_MESSAGE_INVALID_CREDENTIALS,
  ERROR_MESSAGE_LOGIN_FAILED,
  ERROR_MESSAGE_NOT_AUTHORISED,
} from 'Modules/auth/constants/loginErrorCodes'

import { useStore } from 'Stores/index'

import { AuthError, fetchFromApi, fetchFromApiUsingFullPath } from 'Utilities'

import { PortalLogin } from '../PortalLogin/PortalLogin'

export const NewJoinerLogin = observer((props: { isPasswordless: boolean }) => {
  const { isPasswordless } = props

  const { userStore } = useStore()
  const { user } = userStore
  const intl = useIntl()

  const [errorMessage, setErrorMessage] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [customFeedback, setCustomFeedback] = useState('')

  const getApiErrorMessage = (error: Error | null) => {
    if (error instanceof AuthError && error.apiErrors) {
      switch (error.apiErrors[0].code) {
        case 'notAuthorized':
          return ERROR_MESSAGE_NOT_AUTHORISED
        case 'invalidCredentials':
          return ERROR_MESSAGE_INVALID_CREDENTIALS
        default:
          return ERROR_MESSAGE_LOGIN_FAILED
      }
    } else {
      return ERROR_MESSAGE_LOGIN_FAILED
    }
  }

  const customLoginSubmit = (identifier: string, token: string) => {
    setIsSubmitting(true)

    fetchFromApi('/auth/token-login', {
      body: JSON.stringify({
        identifier,
        token,
      }),
      method: 'POST',
    })
      .then(async () => {
        localStorage.setItem('newJoiner', 'true')

        // TODO: Get rid of old API
        const user = await fetchFromApi('/auth/user/me')

        if (user.jwt) {
          window.location.href = '/portal/app/new-joiner/'
        } else {
          setErrorMessage(getApiErrorMessage(null))
        }
      })
      .catch(error => {
        setErrorMessage(getApiErrorMessage(error))

        setIsSubmitting(false)
      })
  }

  const customPasswordlessLoginSubmit = (email: string) => {
    setCustomFeedback('')
    setIsSubmitting(true)

    fetchFromApiUsingFullPath(`${window.GO_API_URL}/passwordless-send-email`, {
      body: JSON.stringify({
        email,
      }),
      method: 'POST',
    })
      .then(async () => {
        localStorage.setItem('newJoiner', 'true')

        setErrorMessage('')

        setIsSubmitting(false)

        setCustomFeedback(
          intl.formatMessage({
            id: 'PortalLogin_passwordless_feedback',
          }),
        )
      })
      .catch(error => {
        setErrorMessage(getApiErrorMessage(error))

        setIsSubmitting(false)
      })
  }

  if (user.jwt) {
    return <Navigate to="/portal/app/new-joiner/" />
  }

  return (
    <PortalLogin
      customErrorMessage={errorMessage}
      customFeedbackMessage={customFeedback}
      customIsSubmitting={isSubmitting}
      customShowSubmit
      customSubmit={
        isPasswordless ? customPasswordlessLoginSubmit : customLoginSubmit
      }
      isNewJoiner
      isPasswordless={isPasswordless}
      resetCustomErrorMessage={() => setErrorMessage('')}
    />
  )
})
